<script>
import { mapActions } from 'vuex';
import { result } from 'lodash';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewPasswordDialog',
  mixins: [validatorMixin, snackbarMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      formData: {
        password: '',
        rePassword: '',
      },
      showPassword: false,
      showRePassword: false,
      rules: {
        password: { required: true, range: { min: 8, max: 20 } },
        rePassword: { required: true },
      },
    };
  },
  computed: {
    isPasswordsValid() {
      return this.checkPasswordEquality()
        && (this.formData.password.length >= 8 && this.formData.rePassword.length >= 8);
    },
  },
  created() {
    this.isVisible = true;
  },
  beforeDestroy() {
    this.isVisible = false;
  },
  mounted() {
    this.formData.id = this.user.id;
    this.formData.username = this.user.username;
    this.formData.tenantId = this.user.tenantId;
  },
  methods: {
    ...mapActions('userDetails', ['saveUser']),
    close() {
      this.$emit('cancel');
    },
    changePassword() {
      if (!this.checkPasswordEquality()) {
        this.showErrorMessage('Die Passwörter stimmen nicht überein.');

        return;
      }

      this.isLoading = true;

      this.saveUser(this.formData)
        .then(() => {
          this.showSuccessMessage('Das Passwort wurde erfolgreich geändert.');
          this.$emit('changePassword');
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    checkPasswordEquality() {
      return this.formData.password === this.formData.rePassword;
    },
  },
};
</script>

<template>
  <div>
    <v-dialog
      v-model="isVisible"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          Bevor Sie sich anmelden, sollten Sie das Passwort ändern.
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="formData.password"
                :error-messages="validationErrorMessages.password"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                label="Neues Passwort"
                @click:append="showPassword = !showPassword"
                :placeholder="' '"
                color="#4C4C78"
                id="password"
                class="js-username-input"
              />
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="formData.rePassword"
                :error-messages="validationErrorMessages.rePassword"
                :append-icon="showRePassword ? 'visibility_off' : 'visibility'"
                :type="showRePassword ? 'text' : 'password'"
                label="Passwort wiederholen"
                @click:append="showRePassword = !showRePassword"
                :placeholder="' '"
                color="#4C4C78"
                class="js-username-input"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="red darken-2"
            class="no-text-transform"
            flat small
            @click="close"
          >
            Schließen
          </v-btn>

          <v-btn
            :loading="isLoading"
            :disabled="!isPasswordsValid"
            :dark="isPasswordsValid"
            color="success"
            class="no-text-transform"
            depressed small
            @click="changePassword"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
